import React, { useState, useEffect, useRef  } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const sections = [
    { title: "Sports", icon: "icon-sports_1cffa65d", type: "SPORTS" },
    { title: "Casino", icon: "icon-live_ac757f68", type: "LIVE" },
    { title: "Slot", icon: "icon-rng_1ce51696", type: "SLOT" },
    { title: "Table", icon: "icon-table_b56addc3", type: "TABLE" },
    { title: "Crash", icon: "icon-crush_a699c529", type: "EGAME" },
    { title: "Fishing", icon: "icon-fish_f1f386cf", type: "FH" },
    { title: "Lottery", icon: "icon-lott_773c2cb1", type: "LOTTO" },
    
];

const sportsOptions = [
    { name: "9wickets", icon: "https://images.1138403.com/prod-images/game_icon/jitabdtf4/h5SmallImage/gcs__SPORTS-U9W_1736836320565.webp", link: "/exchange" },
    { name: "BTi", icon: "https://images.1138403.com/prod-images/game_icon/jitabdtf4/h5SmallImage/gcs__SPORTS-BTI_1736836318305.webp" },
    { name: "LuckySports", icon: "https://images.1138403.com/prod-images/game_icon/jitabdtf4/h5SmallImage/gcs__SPORTS-LUC_1736836318940.webp" },
    { name: "FB SPORTS", icon: "https://images.1138403.com/prod-images/game_icon/jitabdtf4/h5SmallImage/gcs__SPORTS-FB_1736836318516.webp" },
    { name: "United Gaming", icon: "https://images.1138403.com/prod-images/game_icon/jitabdtf4/h5SmallImage/gcs__SPORTS-LUC_1736836318940.webp" },
    { name: "Saba Sports", icon: "https://images.1138403.com/prod-images/game_icon/jitabdtf4/h5SmallImage/gcs__SPORTS-SB_1736836319858.webp" },
    { name: "RCB988 Horsebook", icon: "https://images.1138403.com/prod-images/game_icon/jitabdtf4/h5SmallImage/gcs__SPORTS-RCB_1736836319510.webp" },
    { name: "IA", icon: "https://images.1138403.com/prod-images/game_icon/jitabdtf4/h5SmallImage/gcs__SPORTS-IA_1736836318668.webp" },
];

const GameNavIcon = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [systems, setSystems] = useState([]);
    const [providers, setProviders] = useState([]);
    const [error, setError] = useState(null);
    const [contentPosition, setContentPosition] = useState("0px");
    const navigate = useNavigate();
    const origin = window.location.origin;

    useEffect(() => {
        const selectedSection = sections[activeIndex];
        if (selectedSection.type && selectedSection.type !== "SPORTS") {
            fetchSystems(selectedSection.type);
        } else {
            setSystems([]);
            setProviders([]);
        }
    }, [activeIndex]);
    const handleCasinoClick = (system, type, title) => {
      navigate('/games', { state: { system, type, title } });
  };
  

    const handleSectionClick = (index) => {
        setActiveIndex(index);
        setContentPosition("-100%");
        setTimeout(() => setContentPosition("0px"), 500);
    };

    const fetchSystems = async (type) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-system?type=${type}`);
            const data = await response.json();
            if (response.ok) {
                setSystems(data.systems || []);
                fetchProviders(data.systems);
            } else {
                setError(data.message || 'Failed to fetch systems');
            }
        } catch (error) {
            console.error('Error fetching systems:', error);
            setError('An unexpected error occurred while fetching systems');
        }
    };

    const fetchProviders = async (systems) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-provider?system=${JSON.stringify(systems)}`);
            const data = await response.json();
            if (response.ok) {
                setProviders(data.data || []);
            } else {
                setError(data.message || 'Failed to fetch providers');
            }
        } catch (error) {
            console.error('Error fetching providers:', error);
            setError('An unexpected error occurred while fetching providers');
        }
    };
    const navRef = useRef(null);
    const scrollPosRef = useRef(0);
    useEffect(() => {
        let isScrolling; // Variable to store the debounce timer
    
        // Initially remove the 'active' class when the user first visits
        const navElement = navRef.current;
        navElement.classList.remove('fixed');
    
        // Scroll event handler to check the scroll direction
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
    
            clearTimeout(isScrolling); // Clear any pending debounce timer
    
            // Debounce the scroll event handling to trigger after the user stops scrolling
            isScrolling = setTimeout(() => {
                if (currentScrollPos > scrollPosRef.current) {
                    // Scrolling down, add 'active' class
                    navElement.classList.add('fixed');
                } else {
                    // Scrolling up, remove 'active' class
                    navElement.classList.remove('fixed');
                }
    
                // Update the last scroll position
                scrollPosRef.current = currentScrollPos;
            }, 1); // Adjust the timeout duration as needed for smoother performance
        };
    
        window.addEventListener('scroll', handleScroll);
    
        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
            clearTimeout(isScrolling); // Ensure no timeouts are left running
        };
    }, []);
    

    return (
        <>
      <div className="game-menu">
        <div ref={navRef} id="nav" className="fixed">
          <div className="game-menu-scroll">
            <div className="game-menu-list swiper-wrapper">
            {sections.map((section, index) => (
              <div className={`game-menu-item swiper-slide ${activeIndex === index ? 'on' : ''}`}  onClick={() => handleSectionClick(index)}>
                <svg className={`am-icon am-icon-${section.icon} am-icon-md game-menu-icon`}>
                  <use xlinkHref={`#${section.icon}`} /></svg>
                <span className="game-menu-name">{section.title}</span>
              </div>
               ))}
             
            </div>
          </div>
        </div>
      </div>
      {sections[activeIndex].type === "SPORTS" ? (
      <div className="game-tabs-content on nobg">
          <div className="game-area">
            <div className="top-games">
              <div className="top-games-list">
              {sportsOptions.map((sport, index) => (
                <div className="vendor-item">
                  <Link to={sport.link}>
                  <div className="vendor-icon">
                    <img src={sport.icon} alt="" /></div>
                  <p>{sport.name}</p>
                  </Link>
                </div>
                 ))}
              </div>
            </div>
          </div>
        </div>
          ) : (
            
            <div className="game-tabs-content on">
            <div className="game-area">
              <div className="top-games">
                <div className="top-games-list">
                {providers.length > 0 ? (
                    providers.map((provider, index) => (
                      <div className="vendor-item" key={index}>
                        <a onClick={() => handleCasinoClick(provider.platform, sections[activeIndex].type, sections[activeIndex].title)}>

                          <div className="vendor-icon">
                            <img
                              src={`./icons/platform/${provider.platform}.png`}
                              alt={provider.platform}
                            />
                          </div>
                          <p>{provider.platform}</p>
                        </a>
                      </div>
                    ))
                  ) : (
                    <p></p>
                  )}

                  {/* Add extra empty vendor-item divs if there are less than 8 providers */}
                  {providers.length < 8 && Array.from({ length: 8 - providers.length }).map((_, index) => (
                    <div className="vendor-item" key={providers.length + index}>
                      <Link>
                        <div className="vendor-icon">
                          <img
                              src={`./icons/platform/blank.png`}
                              alt='no Provider'
                           
                            />
                        </div>
                        <p></p> 
                      </Link>
                    </div>
                  ))}

                  
                </div>
              </div>
            </div>
          </div>
          
          )}

        </>
    );
};

export default GameNavIcon;
